import { Column } from '@silevis/reactgrid';

export const getCollaboratorsTabColumns = (): Column[] => [
  { columnId: 'project', width: 200 },
  { columnId: 'role', width: 200 },
  { columnId: 'employee', width: 200 },
  { columnId: 'action', width: 100 },
];
